const SET_APP_SPINNER_VISIBLE = (state, value) => {
  state.appSpinnerVisible = value;
};

export default {
  SET_APP_SPINNER_VISIBLE
};
